import React from 'react';
import Lottie from 'react-lottie';
import WorkLottie from '../../../../lotties/it-lottie-2.json';
import {ImArrowRight2} from 'react-icons/im'
import '../../AiDept/AiDeptTech/AiDeptTech.css';


function ItDeptTech ()
{
  
   const lottieAnimation = {
      loop: true,
      autoplay: true,
      animationData: WorkLottie,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
         id:"career-lottie-id" ,
        className:"-lottie-id"
      }
  };
  return ( 
        <>
      <section className='ai-tech-section container'>
        <div className='ai-tech-content-div'>
          <div className='row'>
            <div className='col-md-6 col-12'>
              <div className='Ml-tech-lottie-div'>
                <Lottie options={lottieAnimation}
                  style={{ height: 350, width: 350 }}
                />
              </div>
            </div>

            <div className='col-md-6 col-12'>
              <div className='ai-tech-div'>
                <h1 className='ai-tech-h1'>ASSISTING ROBUST 
TECHNICAL SOLUTIONS</h1>

                <ul className='ai-tech-ul'>
                  <li className='ai-tech-li'>
                    <ImArrowRight2 className='ai-tech-icon'/>
                    <p className='ai-tech-p'>Application Development</p>
                  </li>
                  <li className='ai-tech-li'>
                    <ImArrowRight2 className='ai-tech-icon'/>
                    <p className='ai-tech-p'>Digital Transformation</p>
                  </li>
                  <li className='ai-tech-li'>
                    <ImArrowRight2 className='ai-tech-icon'/>
                    <p className='ai-tech-p'>Cloud Computing</p>
                  </li>
                  <li className='ai-tech-li'>
                    <ImArrowRight2 className='ai-tech-icon'/>
                    <p className='ai-tech-p'>Channel extension</p>
                  </li>
                  <li className='ai-tech-li'>
                    <ImArrowRight2 className='ai-tech-icon'/>
                    <p className='ai-tech-p'>Cost optimization</p>
                  </li>
                  <li className='ai-tech-li'>
                    <ImArrowRight2 className='ai-tech-icon'/>
                    <p className='ai-tech-p'>DevOps Enablement</p>
                  </li>
                  <li className='ai-tech-li'>
                    <ImArrowRight2 className='ai-tech-icon'/>
                    <p className='ai-tech-p'>Development Re-engineering</p>
                  </li>
                  <li className='ai-tech-li'>
                    <ImArrowRight2 className='ai-tech-icon'/>
                    <p className='ai-tech-p'>IT Infrastructure Upgrade</p>
                  </li>
                  <li className='ai-tech-li'>
                    <ImArrowRight2 className='ai-tech-icon'/>
                    <p className='ai-tech-p'>Quality and security</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
   );
}

export default ItDeptTech;